




import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from './../../api/api';

@Component({
  components: {
  },
})
export default class RealDateTime extends Vue {
  @Prop() private date!: api.DateTime;
}
